module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "calibre4"
  }, [_vm._v("Eislauf")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Auf spiegelndem Teiche"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nzieh' ich spiegelnde Gleise."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nDer Kauz ruft leise."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nDer Mond, der bleiche,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nliegt über dem Teiche.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Im raschelnden Schilfe,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nda weben die Mären,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nda lachet der Sylphe"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nin silbernen Zähren,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ntief innen im Schilfe.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre3 pcalibre1 pcalibre2",
    attrs: {
      "id": "page29",
      "title": "wedi/Konmax"
    }
  }), _vm._v(" Hei, fröhliches Kreisen,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndem Winde befohlen!"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nGlückseliges Reisen,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndie Welt an den Sohlen,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nin eigenen Kreisen!")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Vergessen, vergeben,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nim Mondlicht baden;"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nhingaukeln und schweben"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nauf nächtigen Pfaden!"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nSich selber nur leben!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a295cad0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0014.vue
// module id = 96
// module chunks = 0